export default class Chamado {
    _id;
    _data;
    _hora;
    _leito;
    _tipoChamado;
    _posicao;
    _dtFinalizacao;
    _hrFinalizacao;
    _dtCancelamento;
    _hrCancelamento;
    _motivo;
    _letraEquipamento;
    _letraChamado;
    _avaliacao;

    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }

    get data() {
        return this._data;
    }
    set data(value) {
        this._data = value;
    }

    get hora() {
        return this._hora;
    }
    set hora(value) {
        this._hora = value;
    }

    get leito() {
        return this._leito;
    }
    set leito(value) {
        this._leito = value;
    }

    get tipoChamado() {
        return this._tipoChamado;
    }
    set tipoChamado(value) {
        this._tipoChamado = value;
    }

    get posicao() {
        return this._posicao;
    }
    set posicao(value) {
        this._posicao = value;
    }

    get dtFinalizacao() {
        return this._dtFinalizacao;
    }
    set dtFinalizacao(value) {
        this._dtFinalizacao = value;
    }

    get hrFinalizacao() {
        return this._hrFinalizacao;
    }
    set hrFinalizacao(value) {
        this._hrFinalizacao = value;
    }

    get dtCancelamento() {
        return this._dtCancelamento;
    }
    set dtCancelamento(value) {
        this._dtCancelamento = value;
    }

    get hrCancelamento() {
        return this._hrCancelamento;
    }
    set hrCancelamento(value) {
        this._hrCancelamento = value;
    }

    get motivo() {
        return this._motivo;
    }
    set motivo(value) {
        this._motivo = value;
    }

    get letraEquipamento() {
        return this._letraEquipamento;
    }
    set letraEquipamento(value) {
        this._letraEquipamento = value;
    }

    get letraChamado() {
        return this._letraChamado;
    }
    set letraChamado(value) {
        this._letraChamado = value;
    }

    get avaliacao() {
        return this._avaliacao;
    }
    set avaliacao(value) {
        this._avaliacao = value;
    }

    constructor(pId, pData, pHora, pLeito, pTipoChamado, pPosicao, pDtFinalizacao, pHrFinalizacao, pDtCancelamento, 
        pHrCancelamento,pMotivo,pLetraEquipamento,pLetraChamado,pAvaliacao) {
        this.id = pId;
        this.data = pData;
        this.hora = pHora;
        this.leito = pLeito;
        this.tipoChamado = pTipoChamado;
        this.posicao = pPosicao;
        this.dtFinalizacao = pDtFinalizacao;
        this.hrFinalizacao = pHrFinalizacao;
        this.dtCancelamento = pDtCancelamento;
        this.hrCancelamento = pHrCancelamento;
        this.motivo = pMotivo;
        this.letraEquipamento = pLetraEquipamento;
        this.letraChamado = pLetraChamado;
        this.avaliacao = pAvaliacao;
    }
}